import React, { FunctionComponent } from "react";
import Button from "@material-ui/core/Button";
import {Grid} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

type ItemCartonDialogProps = {
  openConfirmation: boolean;
  cartonFlag: boolean;
  cartonData:any;
  closeCartonDialog: () => void;
  updateSelectedCarton: (value:string) => void;
  resetForm: () => void;
  submitConfirmation: (resetForm:()=>void)=>void;
};
export const CartonConfirmationDialog: FunctionComponent<
  ItemCartonDialogProps
> = ({
    openConfirmation,
    cartonFlag,
    cartonData,
    closeCartonDialog,
    updateSelectedCarton,
    submitConfirmation,
    resetForm
}) => {
  return (
    <Dialog
        open={openConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {cartonFlag===true?(
            <DialogContentText id="alert-dialog-description"> 
            {"Are you sure you want to return an item from the Carton ?"}                               
          </DialogContentText>
          ):(
            <div>
            <DialogTitle id="simple-dialog-title">
              Please select a carton for returning your item :
            </DialogTitle>

        <Grid container style={{paddingTop:"2em"}}>
          <Grid item >
            <RadioGroup
              aria-label="position"
              row
              name="value"
              onChange={(event: any) => {
                updateSelectedCarton(event.target.value);
                
                //setValue(event.target.value);
              }}
              //value={value}
            >
              {cartonData.map((i:any)=>
                 <FormControlLabel
                 value={i.pdct_uom_code}
                 control={<Radio color="primary" />}
                 label={i.uom_name}
                 labelPlacement="end"
               />

              )}
              
            </RadioGroup>
          </Grid>
        </Grid>
        </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            submitConfirmation(resetForm);
          }} id="buton">
          {cartonFlag===true? "Yes":"Submit"}
          </Button>
          <Button
            onClick={() => {
              closeCartonDialog();          
            }}
            autoFocus
            id="buton"
          >
            {cartonFlag===true? "No":"Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
  );
};
